import ModalSendBatch from './ModalSendBatch';

export default ModalSendBatch;
